// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gdpr[data-v-1e6838a9]{background-color:#dbdbdb;padding:1rem 2rem 1rem 1rem}.gdpr-close[data-v-1e6838a9]{position:absolute;right:.5rem;top:.5rem}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
